import { ReactComponent as Slack } from '@shared/assets/icons/ic-slack.svg'
import { ChannelIcon } from 'v2/shared/components/channel-icons'
import { ConvChannels } from 'v2/types/api/conversations'

// V2.9 runs on voice only, so authoring never offers it another channel.
export const channelOptions = (isV29: boolean, slackTriggerEnabled: boolean) => {
  const option = (label: string, value: string, channel: ConvChannels) => ({
    label,
    value,
    icon: <ChannelIcon channel={channel} className="h-4 w-4" />,
  })
  const call = option('Call', 'call', ConvChannels.CALL)
  if (isV29) return [call]
  return [
    option('Message', 'message', ConvChannels.MESSAGE),
    option('WhatsApp', 'whatsapp', ConvChannels.WHATSAPP),
    option('Chat', 'chat', ConvChannels.CHAT),
    call,
    ...(slackTriggerEnabled
      ? [{ label: 'Slack', value: 'slack', icon: <Slack className="h-4 w-4" /> }]
      : []),
  ]
}
